export default __webpack_public_path__ + "static/media/splash.b8a85722.png";